export let addDays = function(date, days = 0) {
  date = new Date(date);
  date.setDate(date.getDate() + days);
  return date;
};

export let substractDays = function(date, days = 0) {
  date = new Date(date);
  date.setDate(date.getDate() - days);
  return date;
};

export let dayDiff = function (date1, date2) {
  date1 = new Date(date1);
  date2 = new Date(date2);
  const timeDiff = Math.abs(date2.getTime() - date1.getTime());
  const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

  return diffDays;
};

export let today = function (mode = '') {
  const date = new Date();

  if (mode === 'UTC') {
    date.setUTCHours(0, 0, 0, 0);
  } else {
    date.setHours(0, 0, 0, 0);
  }

  return new Date(date);
};

export let tomorrow = function (mode = '') {
  const date = new Date();
  if (mode === 'UTC') {
    date.setUTCHours(24, 0, 0, 0);
  } else {
    date.setHours(24, 0, 0, 0);
  }

  return new Date(date);
};

export let yesterday = function (mode = '') {
  const now = today(mode);
  const date = now.setDate(now. getDate() - 1);

  return new Date(date);
};

// Beyond this span a daily series has too many points to read, so the dashboards switch to months.
export const GRANULARITY_SWITCH_DAYS = 92;

// Mirrors the Performances dashboard: no start means "Totalité", which is always monthly.
export let granularityForRange = function (start, end) {
  if (!start) {
    return 'monthly';
  }
  // inclusive day count, so a 92-day period stays daily and 93 flips to monthly
  return dayDiff(start, end) + 1 > GRANULARITY_SWITCH_DAYS ? 'monthly' : 'daily';
};
